<div class="frequency-table-scroll">
  <ag-grid-angular
    class="ag-theme-basic-table frequency-table-grid"
    [style.width.px]="gridWidth()"
    [rowData]="rowData()"
    [columnDefs]="columnDefs()"
    [gridOptions]="gridOptions"
  >
  </ag-grid-angular>
</div>
